module.exports = __webpack_public_path__ + "img/pasta-en-saus.39dcb245.jpeg";